import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import { AnalyticsPage } from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

type PersonalApiKeysManagedUsersCalloutProps = {
  analyticsPage: AnalyticsPage;
};

const PersonalApiKeysManagedUsersCallout = ({
  analyticsPage,
}: PersonalApiKeysManagedUsersCalloutProps) => {
  const { viewer } = useTypedContext(AccountContext);

  return (
    <Callout variant="warning" title="Personal API keys require Identity Access Management">
      Your organization signs in through a login policy. Personal API keys are only available to
      organizations using Identity Access Management, because a personal key inherits the
      permissions Spacelift holds for a specific person.
      {viewer.admin ? (
        <>
          {
            " To enable Personal API keys for your organization, change the management strategy to IAM."
          }
          <FeedbackActions>
            <LinkButton
              to="/settings/management-strategy/"
              analyticsPage={analyticsPage}
              analyticsTitle="Callout Strategy Click"
              variant="contrast"
              size="small"
            >
              Choose organization strategy
            </LinkButton>
          </FeedbackActions>
        </>
      ) : (
        " To use Personal API keys, ask your admin to change the management strategy for your organization to IAM."
      )}
    </Callout>
  );
};

export default PersonalApiKeysManagedUsersCallout;
